module.exports = "/* You can add global styles to this file, and also import other style files */\r\n\r\nbody{\r\n  margin: 0%;\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./node_modules/postcss-loader/lib??embedded!./src/styles.css
// module id = ./node_modules/raw-loader/index.js!./node_modules/postcss-loader/lib/index.js??embedded!./src/styles.css
// module chunks = styles